module.exports = __webpack_public_path__ + "img/solu3.37127d44.png";